{
  "chat": {
    "title": "DreamBot",
    "subtitle": "Asesor de Sueño IA",
    "placeholder": "Pregunta sobre sueño, dolor o productos...",
    "send": "Enviar mensaje",
    "restart": "Reiniciar Chat",
    "close": "Cerrar chat",
    "toggleTheme": "Cambiar tema",
    "typing": "DreamBot está escribiendo...",
    "error": {
      "generic": "Algo salió mal. Por favor, inténtalo de nuevo.",
      "network": "Error de red. Verifica tu conexión.",
      "timeout": "Tiempo de espera agotado. Inténtalo de nuevo.",
      "retry": "Intentar de Nuevo"
    }
  },
  "greeting": {
    "welcome": "¡Bienvenido a Mattress Unboxed! Soy DreamBot. Para encontrar tu configuración de sueño perfecta, dime: ¿cómo sueles dormir?",
    "continueConversation": "¡Bienvenido de nuevo!",
    "continueDescription": "¿Te gustaría continuar donde lo dejaste o comenzar una conversación nueva?",
    "continueButton": "Continuar conversación",
    "startNewButton": "Comenzar de nuevo"
  },
  "quiz": {
    "sleepPosition": {
      "question": "¿Cómo sueles dormir?",
      "side": "De Lado",
      "back": "Boca Arriba",
      "stomach": "Boca Abajo",
      "combination": "Combinación"
    },
    "painPoints": {
      "question": "¿Experimentas alguna molestia específica al despertar?",
      "lowerBack": "Dolor Lumbar",
      "shoulder": "Dolor de Hombro",
      "hot": "Calor Excesivo",
      "none": "Sin Dolor"
    },
    "firmness": {
      "question": "En cuanto a la sensación, ¿qué prefieres normalmente?",
      "soft": "Suave como Nube",
      "medium": "Medio Perfecto",
      "firm": "Firme y Soportivo"
    },
    "budget": {
      "question": "¿Cuál es tu presupuesto aproximado?",
      "under1000": "Menos de $1000",
      "standard": "$1000 - $1600",
      "luxury": "El precio no es problema"
    },
    "bedSize": {
      "question": "¿Qué tamaño de cama buscas?",
      "twin": "Individual",
      "twinXL": "Individual XL",
      "full": "Matrimonial",
      "queen": "Queen",
      "king": "King",
      "calKing": "Cal King"
    }
  },
  "recommendations": {
    "analyzing": "Analizando tu perfil de sueño...",
    "bestMatch": "Mejor opción general:",
    "alternative": "Alternativa sólida:",
    "anotherOption": "Otra gran opción:",
    "viewDetails": "Ver detalles",
    "warranty": "Preguntar sobre Garantía",
    "shipping": "Info de Envío",
    "startOver": "Comenzar de Nuevo"
  },
  "suggestions": {
    "quickStarts": "Inicios rápidos",
    "findPerfect": "Ayúdame a encontrar el colchón perfecto",
    "whatSpecial": "¿Qué hace especiales a tus colchones?",
    "bestSellers": "Cuéntame sobre tus más vendidos",
    "backPain": "Necesito ayuda con dolor de espalda"
  },
  "accessibility": {
    "inputDescription": "Escribe tu mensaje y presiona Enter para enviar",
    "liveRegion": "DreamBot dice: {{message}}",
    "quickReplyGroup": "Opciones de respuesta rápida",
    "quickReply": "Respuesta rápida: {{label}}",
    "closeInstruction": "Cerrar chat (Ctrl+K o deslizar hacia abajo)",
    "zoomInstruction": "Desplazar para acercar • Clic y arrastrar para mover"
  }
}
